export const WorkData = [
  {
    company: 'BootCamp Year',
    designation: 'Student',
    dateJoining: '2022',
    dateEnd: '2022',
    companyLogo:
      'https://cdn.ampmarketing.co.za/wp-content/uploads/2019/06/CodeCollege.jpg',
    work: 'My experience through CodeCollege has been immense to say the least. I have grown as a developer on a exponential level, at a degree I did not think was possible. Throughout this entire year I have been faced with challenges that I thought I could have never overcome. As development has taught me there is always a solution to a problem. We can always make it work. Please see my GitHub link belowe to see my entire range of projects.',
    github: 'https://github.com/SeanJordaan/randomAdvice-',
  },
];
